import {useState, useEffect, useRef} from "react";
import SectionTitleTwo from '../../components/SectionTitles/SectionTitleTwo';
import AccordionWrap from '../../components/Accordion/AccordionWrap.jsx';
import Tilt from 'react-parallax-tilt';
import Parallax from 'parallax-js';

const Faq = () => {
    const [scale] = useState(1.04);
    const sceneEl = useRef(null);
    useEffect(() => {
        const parallaxInstance = new Parallax(sceneEl.current, {
        relativeInput: true,
        })
        
        parallaxInstance.enable();

        return () => parallaxInstance.disable();

    }, [])
    return (
        <div className="faq-section section section-padding-top bg-primary-blue">
            <div className="container">
                <div className="row row-cols-lg-2 row-cols-1 mb-n6">
                    <div className="col-xl-5 col-lg-6 col-12" data-aos="fade-up">
                        <div className="faq-content">
                            <SectionTitleTwo 
                                subTitle="Frequently Asked Questions"
                                title="You’ve got questions and <br/> we’ve got answers"
                            />

                            <AccordionWrap />
                            
                        </div>
                    </div>
                    <div className="col-xl-7 col-lg-6 col-12" data-aos="fade-up">
                        <div className="about-image-area">
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/Fungible-multichain-icon8.png"} alt="Fungible Strategy Multichain" />
                                </Tilt>
                            </div>

                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/Fungible-strategy-network4.png"} alt="Fungible Strategy" />
                                </Tilt>
                            </div>
                           

                            <div className="shape shape-1" id="scene" ref={sceneEl}>
                                <span data-depth="1"><img src={process.env.PUBLIC_URL + "images/shape-animation/about-shape-1.png"} alt="" /></span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faq;
